// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data/jenkins/workspace/CMDB-dev-app-function/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/face-recognition",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceRecognition' */'@/pages/faceRecognition'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/fase-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceRecognition__ResultPage' */'@/pages/faceRecognition/ResultPage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/success-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceRecognition__successPage' */'@/pages/faceRecognition/successPage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/fail-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceRecognition__failPage' */'@/pages/faceRecognition/failPage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/credentials",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials' */'@/pages/credentials'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/idNo-credential",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__id' */'@/pages/credentials/id'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/face-credential",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__face__faceIndex' */'@/pages/credentials/face/faceIndex'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/credential-face-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__face__result' */'@/pages/credentials/face/result'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/face-success-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__face__successPage' */'@/pages/credentials/face/successPage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/face-fail-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__face__failpage' */'@/pages/credentials/face/failpage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__lawyerIndex' */'@/pages/credentials/lawyer/lawyerIndex'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential-edit",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__edit' */'@/pages/credentials/lawyer/edit'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__result' */'@/pages/credentials/lawyer/result'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential-success",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__success' */'@/pages/credentials/lawyer/success'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential-fail",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__fail' */'@/pages/credentials/lawyer/fail'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-credential-pending",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__credentials__lawyer__pending' */'@/pages/credentials/lawyer/pending'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/case-advertise",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tiangong__advertise' */'@/pages/tiangong/advertise'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/case-register-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tiangong__registerSuccess' */'@/pages/tiangong/registerSuccess'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/agreement",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tiangong__agreement' */'@/pages/tiangong/agreement'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/register-guide",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tiangong__registerGuide' */'@/pages/tiangong/registerGuide'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawyer-apply-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tiangong__lawyerApplyResult' */'@/pages/tiangong/lawyerApplyResult'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawfirm-create",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lawfirm__lawfirmRegister' */'@/pages/lawfirm/lawfirmRegister'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/lawfirm-create-result",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lawfirm__lawfirmCreateResult' */'@/pages/lawfirm/lawfirmCreateResult'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/invitation",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lawfirm__invitation' */'@/pages/lawfirm/invitation'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
